export default __webpack_public_path__ + "static/media/laser.8a7c3b78.png";